import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';

export const lawyerOfferNeeded = async (lawyerId: string) => {
  return (
    await companyCreationAxiosInstance.post(
      `v1/customer/companyCreations/offerNeeded/${lawyerId}`
    )
  ).data;
};
